import { MaintenanceWindowPreviewPatchManagementWebComponent } from './component/MaintenanceWindowPreviewPatchManagementWebComponent';
import { WEB_COMPONENT_MAINTENANCE_WINDOW_PREVIEW_PATCH_MANAGEMENT } from '../../webcomponents.constants';

export { MaintenanceWindowPreviewPatchManagementWebComponent };

window.customElements.define(
  WEB_COMPONENT_MAINTENANCE_WINDOW_PREVIEW_PATCH_MANAGEMENT,
  MaintenanceWindowPreviewPatchManagementWebComponent
);
